import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Form,
  Input,
  message,
  Modal,
  Space,
  Table,
  Tag,
  Card,
  Row,
  Col,
  Switch,
  Typography,
  Rate,
  Select,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { AiFillDelete, AiOutlineCheckCircle } from "react-icons/ai";
import userCustomerApi from "../../api/userCustomerApi";
import reviewApi from "../../api/reviewApi";
import productApi from "../../api/product/productApi";
import TextArea from "antd/lib/input/TextArea";
import Swal from "sweetalert2";
import debounce from "lodash.debounce";
const heart = [
  <svg
    width="22"
    height="22"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={0}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.17157 5.17157C4.73367 3.60948 7.26633 3.60948 8.82843 5.17157L10 6.34315L11.1716 5.17157C12.7337 3.60948 15.2663 3.60948 16.8284 5.17157C18.3905 6.73367 18.3905 9.26633 16.8284 10.8284L10 17.6569L3.17157 10.8284C1.60948 9.26633 1.60948 6.73367 3.17157 5.17157Z"
      fill="red"
    ></path>
  </svg>,
];
const Reviews = (props) => {
  const { Title } = Typography;
  const { Option } = Select;

  const [form] = Form.useForm();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [valueForm, setValueForm] = useState(null);
  const [btnDeleted, setBtnDeleted] = useState(false);
  const [listDeleted, setListDeleted] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isEditModalShow, setIsEditModalShow] = useState(false);

  const [totalCount, setTotalCount] = useState(0);
  const [lstReview, setLstReview] = useState([]);

  const [totalCountUser, setTotalCountUser] = useState(0);
  const [lstUser, setLstUser] = useState([]);

  const [totalCountProduct, setTotalCountProduct] = useState(0);
  const [lstProduct, setLstProduct] = useState([]);

  const [inputFilter, setFilter] = useState({
    product: null,
    status: null,
    keyword: null,
    sortBy: "createdAt:desc",
    page: 1,
    limit: 10,
  });

  useEffect(() => {
    getReviews();
  }, [inputFilter]);

  const getReviews = () => {
    setLoading(true);
    reviewApi.getReviews(inputFilter).then((res) => {
      if (res?.results) {
        // const data = res?.results.filter((item) => !item.isAdmin);
        setLstReview(res?.results);
        setTotalCount(res?.totalResults);
      }
      setLoading(false);
    });
  };
  const handleSearch = (e) => {
    setFilter({ ...inputFilter,page: 1, keyword: e.target.value });
  };

  const getReviewsDebounce = useMemo(() => debounce(handleSearch, 300), []);

  useEffect(() => {
    getCustomers();
    getProducts();
  }, []);

  const getCustomers = () => {
    const params = {
      active: true,
      page: 1,
      limit: 100000,
    };
    userCustomerApi.getAll(params).then((res) => {
      if (res?.results) {
        setLstUser(res?.results);
        setTotalCountUser(res?.totalResults);
      }
    });
  };

  const getProducts = () => {
    const params = {
      published: true,
      page: 1,
      limit: 100000,
    };
    productApi.getProducts(params).then((res) => {
      if (res?.results) {
        setLstProduct(res?.results);
        setTotalCountProduct(res?.totalResults);
      }
    });
  };

  const columns = [
    Table.SELECTION_COLUMN,
    {
      title: "STT",
      render: (text, record, index) => (page - 1) * pageSize + index + 1,
      className: "text-center",
      width: 10,
    },
    Table.EXPAND_COLUMN,
    {
      title: "Khách hàng",
      dataIndex: "customerName",
      render: (text) => <span>{text ? text : "Admin"}</span>,
      width: 100,
    },
    // {
    //   title: "Mã đơn hàng",
    //   dataIndex: "order",
    //   render: (text) => <h6>#{text}</h6>,
    //   width: 50,
    // },
    {
      title: "Sản phẩm",
      dataIndex: "productName",
      render: (text) => <h6>{text}</h6>,
      width: 100,
    },
    {
      title: "Đánh giá",
      dataIndex: "content",
      render: (text) => <span>{text}</span>,
      className: "whiteSpace-nowrap",
      width: 250,
    },
    {
      title: "Số sao đánh giá",
      dataIndex: "star",
      render: (star) => (
        <>
          <Title level={2}> {star}</Title> <Rate disabled defaultValue={star} />
        </>
      ),
      className: "text-center",
      width: 50,
    },
    {
      title: "Hữu ích",
      dataIndex: "like",
      render: (like) => (
        <>
          <Title level={2}>
            {like}
          </Title>
          {heart}
        </>
      ),
      className: "text-center",
      width: 50,
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      render: (status) => (
        <>
          {status === 1 && (
            <Tag color="green" key={status}>
              Đã duyệt
            </Tag>
          )}
          {status === 0 && (
            <Tag color="red" key={status}>
              Chưa duyệt
            </Tag>
          )}
        </>
      ),
      width: 50,
      className: "text-center",
    },
    {
      title: "Hành động",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          {record.status === 1 ? (
            <Link to={"/review/" + record.id}>
              <Button value="large" icon={<EyeOutlined />}>
                Xem
              </Button>
            </Link>
          ) : (
            <Button
              onClick={() => changeStatus(record)}
              value="large"
              icon={<AiOutlineCheckCircle />}
            >
              &nbsp; Duyệt
            </Button>
          )}
          <Button
            value="large"
            type="primary"
            icon={<DeleteOutlined />}
            danger
            onClick={() => deleteReview(record)}
          >
            Xóa
          </Button>
        </Space>
      ),
      width: 150,
      className: "text-center",
      // fixed: "right",
    },
  ];

  function onChange(pagination, filters, sorter, extra) {
    setPageSize(pagination.pageSize);
    if (pagination && pagination.current) {
      setPage(pagination.current);
    }
    let sort = "createdAt:desc";
    if (sorter && sorter.columnKey) {
      let order = "ASC";
      if (sorter.order === "descend") {
        order = "DESC";
      }
      sort = sorter.columnKey + " " + order;
    }
    setFilter({
      name: inputFilter.name,
      sortBy: sort,
      limit: pagination.pageSize,
      page: pagination.current,
    });
  }

  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    setSelectedRowKeys(newSelectedRowKeys);
    if (newSelectedRowKeys.length > 0) {
      setListDeleted(`${newSelectedRowKeys}`);
      setBtnDeleted(true);
    } else {
      setListDeleted([]);
      setBtnDeleted(false);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      // disabled: record.name === 'Disabled User',
      // Column configuration not to be checked
      name: record.name,
    }),
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const closePopup = useCallback(() => {
    setValueForm({});
    form.resetFields();
    setIsEditModalShow(false);
  }, [form]);

  const onFinish = (values) => {
    createReview(values);
  };

  const createReview = (data) => {
    const payload = {
      customer: data.customer ? data.customer : null,
      content: data.content,
      product: data.product,
      star: data.star,
      status: data.status ? 1 : 0,
      order: null,
      parent: null,
    };
    console.log(payload);

    reviewApi.createReview(payload).then(
      (res) => {
        if (res) {
          Swal.fire({
            title: "Thành Công!",
            text: "Tạo thành công",
            icon: "success",
            confirmButtonText: "OK",
          });
          setIsEditModalShow(false);
          getReviews();
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: "Tạo thất bại",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        console.log(err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const showCreateModal = () => {
    setIsEditModalShow(true);
  };

  const confirm = Modal.confirm;

  const deleteReview = (record) => {
    const data = {
      ids: record.id,
    };
    confirm({
      title: "Bạn có muốn review này không?",
      onOk() {
        reviewApi
          .deleteReview(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công review ");
              getReviews();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  const deleteReviews = () => {
    const data = {
      ids: listDeleted,
    };
    confirm({
      title: "Bạn có muốn xóa các review này không?",
      onOk() {
        reviewApi
          .deleteReviews(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công các review ");
              getReviews();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  const changeStatus = (record) => {
    const data = {
      id: record.id,
      status: 1,
    };
    confirm({
      title: "Bạn có muốn duyệt review này không?",
      onOk() {
        reviewApi
          .changeStatus(data)
          .then((res) => {
            if (res) {
              message.success("Duyệt thành công review!");
              getReviews();
            } else {
              message.error("Duyệt thất bại");
            }
          })
          .catch(() => {
            message.error("Duyệt thất bại");
          });
      },
      onCancel() {},
    });
  };
  return (
    <>
      <div className="tabled">
        <Card>
          <Row gutter={16}>
            <Col span={6}>
              <label> Tìm kiếm</label>
              <Input
                addonAfter={<SearchOutlined />}
                placeholder="Nhập tên khách hàng, mã đơn hàng , sản phẩm..."
                onChange={getReviewsDebounce}
                style={{
                  width: "100%",
                }}
              />
            </Col>
            <Col span={6}>
              {" "}
              <label> Sản phẩm</label>
              <Select
                value={inputFilter.product}
                placeholder="Chọn để tìm kiếm..."
                size="large"
                style={{
                  width: "100%",
                }}
                defaultValue=""
                onChange={(e) => {
                  setFilter({ ...inputFilter, page: 1,product: e });
                }}
              >
                {" "}
                <Option value="">--- Mặc định ---</Option>
                {lstProduct == null ||
                lstProduct === "undefined" ||
                lstProduct === []
                  ? []
                  : lstProduct.map((item, key) => (
                      <Option key={key} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
              </Select>
            </Col>
            <Col span={6}>
              <label> Trạng thái</label>
              <Select
                value={inputFilter.status}
                placeholder="Chọn để tìm kiếm..."
                size="large"
                style={{
                  width: "100%",
                }}
                defaultValue=""
                onChange={(e) => {
                  setFilter({ ...inputFilter, page: 1,status: e });
                }}
              >
                <Option value="">--- Mặc định ---</Option>
                <Option value="1">Đã duyệt</Option>
                <Option value="0">Chưa duyệt</Option>
              </Select>
            </Col>
          </Row>
        </Card>

        <br />
        <Space size={10}>
          <Button type="dashed" size="small" onClick={() => showCreateModal()}>
            <EditOutlined /> &nbsp; Thêm đánh giá
          </Button>

          {btnDeleted ? (
            <Button
              value="small"
              type="primary"
              icon={<AiFillDelete />}
              danger
              onClick={() => {
                deleteReviews();
              }}
            >
              &nbsp; Xóa các mục được chọn
            </Button>
          ) : null}
        </Space>
        <br />
        <br />
        <Card bordered={true} className="criclebox tablespace mt-10 mb-24">
          <div className="table-responsive">
            <Table
              rowSelection={{
                ...rowSelection,
              }}
              tyle={{ wordWrap: "break-word", wordBreak: "break-word" }}
              scroll={{ x: true }}
              rowKey={(record) => record.id.toString()}
              loading={loading}
              onChange={onChange}
              columns={columns}
              dataSource={lstReview}
              bordered
              className="ant-border-space"
              pagination={{
                pageSize: pageSize,
                total: totalCount,
                pageSizeOptions: ["10", "50", "100", "200"],
              }}
            />
          </div>
        </Card>

        <Modal
          title=""
          visible={isEditModalShow}
          onOk={form.submit}
          onCancel={() => {
            closePopup();
          }}
          style={{ top: 20 }}
        >
          <div>
            <Form
              initialValues={valueForm}
              form={form}
              name="basic"
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item label="Khách hàng" name="customer">
                <Select
                  showArrow
                  showSearch
                  size="large"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  placeholder="Chọn..."
                >
                  {lstUser == null || lstUser === "undefined" || lstUser === []
                    ? []
                    : lstUser.map((item, key) => (
                        <Option key={key} value={item.id}>
                          {item.name}
                        </Option>
                      ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Sản phẩm"
                name="product"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn sản phẩm!",
                  },
                ]}
              >
                <Select
                  showArrow
                  showSearch
                  size="large"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  placeholder="Chọn..."
                >
                  {lstProduct == null ||
                  lstProduct === "undefined" ||
                  lstProduct === []
                    ? []
                    : lstProduct.map((item, key) => (
                        <Option key={key} value={item.id}>
                          {item.name}
                        </Option>
                      ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Số sao đánh giá"
                name="star"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn số sao!",
                  },
                ]}
              >
                <Rate />
              </Form.Item>
              <Form.Item
                label="Trạng thái"
                valuePropName="checked"
                name="status"
              >
                <Switch />
              </Form.Item>
              <Form.Item
                label="Nội dung đánh giá"
                name="content"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập!",
                  },
                ]}
              >
                <TextArea rows={4} placeholder="Nhập nội dung ..." />
              </Form.Item>
            </Form>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default Reviews;
